import * as React from 'react';
import View from './view';
import {useDispatch, useSelector} from 'react-redux';
import {Route, useNavigation} from '@react-navigation/native';
import {productDetailedSelector, productsByIdSelector} from '../../../redux/selectors/products';
import {getDetailedProduct} from '../../../redux/actions/products';

function _ProductItemScreen({route}: {route: Route<string>}) {
  //@ts-ignore
  const id = route.params?.id;
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(getDetailedProduct(id));
  }, [id]);

  const product = useSelector(productDetailedSelector());
  const navigation = useNavigation();
  React.useEffect(() => {
    if (product?.name) navigation.setOptions({title: product.name});
  }, [product]);

  const productAcceptors = React.useMemo(() => product?.departments, [product, id]);

  if (!product || !productAcceptors) return <></>;
  return <View product={product} id={id} productAcceptors={productAcceptors} />;
}

export const ProductItemScreen = React.memo(_ProductItemScreen);
